import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import regeneratorRuntime from "/home/jenkins/agent/workspace/web-sunrise-noprod/web-sunrise-stories-deploy-dev/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { ErrorMessage } from "../ErrorMessage/errorMessage";
import * as S from "../../cmsForm.style";
import { getDataFromDAM } from "../../cmsForm.utils";
export var CustomSelect = function(_param) {
    var name = _param.name, label = _param.label, options = _param.options, isColMiddle = _param.isColMiddle, isHidden = _param.isHidden, isDisabled = _param.isDisabled, isPendingRequest = _param.isPendingRequest, urlData = _param.urlData, props = _object_without_properties(_param, [
        "name",
        "label",
        "options",
        "isColMiddle",
        "isHidden",
        "isDisabled",
        "isPendingRequest",
        "urlData"
    ]);
    var ref;
    var ref1 = useFormContext(), register = ref1.register, errors = ref1.formState.errors;
    var ref2 = useState([]), remoteOptions = ref2[0], setRemoteOptions = ref2[1];
    var error = (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message;
    var id = "".concat(name, "-").concat(props.type, "-").concat(label);
    var checkRemoteOptions = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var dataFromDam;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (urlData) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return getDataFromDAM(urlData);
                    case 4:
                        dataFromDam = _ctx.sent;
                        setRemoteOptions(dataFromDam || []);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkRemoteOptions() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        checkRemoteOptions();
    }, []);
    var renderOptions = function() {
        var optionMap = urlData ? remoteOptions : options;
        return optionMap === null || optionMap === void 0 ? void 0 : optionMap.map(function(param) {
            var description = param.description, value = param.value;
            return /*#__PURE__*/ _jsx("option", {
                value: value,
                children: description
            }, value);
        });
    };
    return /*#__PURE__*/ _jsxs(S.StyledCheckboxContainer, {
        isColMiddle: isColMiddle,
        isHidden: isHidden,
        children: [
            /*#__PURE__*/ _jsx(S.StyledFieldset, {
                isError: !!error,
                children: /*#__PURE__*/ _jsxs(S.StyledDropdown, _object_spread_props(_object_spread({}, register(name), props), {
                    disabled: isDisabled || isPendingRequest,
                    id: id,
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: label
                        }),
                        renderOptions()
                    ]
                }))
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error
            })
        ]
    });
};
